import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useAuth } from '../../../lib/auth';
import AuthLayout from '../../layouts/AuthLayout';
import clsx from 'clsx';
import { Tracker } from '../../../components/progresses/Tracker.tsx';
import { CategoriesNav } from '../../../components/navigation/CategoriesNav.tsx';
import RecommendedLectures from '../../../components/dashboardSections/RecommendedLectures.tsx';
import DashboardJoyride from '../../../components/joyride/DashboardJoyride.tsx';
import {
    useFetchRecommendedLectures,
    useFetchRootCategories,
} from '../../../lib/fetches.ts';
import { cn } from '../../../lib/helpers.ts';
import { LastPlayedLectures } from '../../../components/dashboardSections/LastPlayedLectures.tsx';
import { useLocation, useNavigate } from 'react-router-dom';

export default function DashboardPage() {
    const { user } = useAuth({
        middleware: 'auth',
        redirectTo: '/',
        tmp: 'DashboardPage',
    });
    const location = useLocation();
    const navigate = useNavigate();

    if (user?.onboarding_completed_at === null) {
        if (location.pathname !== '/onboarding') {
            navigate('/onboarding');
        }
    }

    const { isLoading: isLoadingRecommendedLectures } =
        useFetchRecommendedLectures();
    const { isLoading: isLoadingCategories } = useFetchRootCategories();

    const isLoadedEverythingForJoyride =
        !isLoadingRecommendedLectures && !isLoadingCategories;

    return (
        <AuthLayout>
            <main
                className={clsx(
                    'mx-auto box-content max-w-6xl py-9',
                    'px-4 sm:px-8 md:px-10',
                    'overflow-x-hidden'
                )}
            >
                <div
                    className={cn(
                        'mb-14 flex justify-between',
                        'flex-col sm:flex-row'
                    )}
                >
                    <div className="mb-8 sm:mb-0">
                        <h1 className="flex items-center justify-start">
                            Ahoj!
                        </h1>
                        <p className="text-lg text-ink-800">
                            Je čas projít další mindfulness cvičení
                        </p>
                    </div>
                    <Tracker />
                </div>

                <div className="relative overflow-x-hidden">
                    <LastPlayedLectures />
                    <div className="absolute right-0 top-[4.25rem] h-64 w-10 bg-gradient-to-r from-transparent to-base-100 xl:-right-4" />
                </div>

                <div className="pb-16">
                    <div className="tour--recommended-lectures">
                        <RecommendedLectures />
                    </div>
                </div>

                <div className="pb-16">
                    <div className="tour--categories-nav">
                        <h2>Kategorie</h2>
                        <CategoriesNav />
                    </div>
                </div>
            </main>
            {!user?.features?.includes('walkthroughCompleted') ? (
                <DashboardJoyride run={isLoadedEverythingForJoyride} />
            ) : null}
        </AuthLayout>
    );
}
